import {InputProps} from "./interface";
import getType from "./types";
import React from "react";

const Input = (props: InputProps): React.JSX.Element | null => {
  return getType(props);
};

export default Input;
